import { extractVariantsFromProductName } from './utils/product.js';
import { getCookie, setCookie } from 'cookies-next';
import { r as COOKIE_ACCOR_GTM_CART_TRACKING } from './cookies-VX_DpI1q.js';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';

function calculateDiscount(originalPrice, currentPrice) {
    const discount = originalPrice - currentPrice;
    const roundedDiscount = Number(discount.toFixed(2));
    return roundedDiscount;
}
// TODO: This is not so reliable, we need to find a better way to detect size variants
const isSizeVariant = (variant) => {
    const sizeRegex = /\b\d+\s*x\s*\d+\s*(x\s*\d+)?\s*(cm|mm|in|ft)?\b/;
    return sizeRegex.test(variant);
};
// TODO: This is not so reliable, we need to find a better way to detect bed size variants
const isBedSizeVariant = (variant) => {
    const bedSizes = ['single', 'twin', 'double', 'queen', 'king', 'super king'];
    return bedSizes.includes(variant.toLowerCase());
};
const getItemVariantsWithoutSize = (configured_variant, siteFilters) => {
    var _a;
    if (!configured_variant)
        return { extractedVariants: '', removedSizeVariant: '' };
    const extractedVariants = extractVariantsFromProductName({
        name: ((_a = configured_variant === null || configured_variant === void 0 ? void 0 : configured_variant.name_en) === null || _a === void 0 ? void 0 : _a.product_name) || (configured_variant === null || configured_variant === void 0 ? void 0 : configured_variant.name),
        siteFilters: siteFilters || null,
    }).split(';');
    const extractedVariantsWithoutBedSize = extractedVariants.filter(el => !isBedSizeVariant(el));
    const sizeVariantIndex = extractedVariantsWithoutBedSize.findIndex(el => isSizeVariant(el));
    const removedSizeVariant = extractedVariantsWithoutBedSize.splice(sizeVariantIndex, 1);
    return {
        extractedVariants: extractedVariantsWithoutBedSize.join('|'),
        removedSizeVariant: removedSizeVariant[0].replaceAll('cm', '').trim(),
    };
};
class AccorGtmCartTracking {
}
AccorGtmCartTracking.updateCart = ({ items, itemListName = '', op, }) => {
    var _a;
    const cartDataCookie = (_a = getCookie(COOKIE_ACCOR_GTM_CART_TRACKING)) === null || _a === void 0 ? void 0 : _a.toString();
    const cartData = cartDataCookie ? JSON.parse(cartDataCookie) : {};
    items.forEach(item => {
        if (op === 'remove') {
            delete cartData[item.product.sku];
            return;
        }
        cartData[item.product.sku] = itemListName;
    });
    setCookie(COOKIE_ACCOR_GTM_CART_TRACKING, JSON.stringify({ ...cartData }));
};

export { AccorGtmCartTracking as A, calculateDiscount as c, getItemVariantsWithoutSize as g };
//# sourceMappingURL=helpers-WYINLSKJ.js.map
